import { render, staticRenderFns } from "./Supply.vue?vue&type=template&id=58920d0e&scoped=true&"
import script from "./Supply.vue?vue&type=script&lang=js&"
export * from "./Supply.vue?vue&type=script&lang=js&"
import style0 from "./Supply.vue?vue&type=style&index=0&id=58920d0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58920d0e",
  null
  
)

export default component.exports